import React from 'react';

import { TouchableOpacity, View } from 'react-native';

import { SvgProps } from 'react-native-svg';

import { AUDIO_LANGUAGE_OPTION, SUBTITLE_OPTION } from 'config/testID';

import { PlayerTrack } from 'store/player/reducer.types';

import { COLOR } from 'utils/colors';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import useAudioAndSubtitleOption from '../../../hooks/useAudioAndSubtitleOption';
import styles from './styles';

type Props = {
    item: PlayerTrack;
    SvgRightImage?: React.ComponentType<SvgProps> | null;
    onPress?(item: PlayerTrack): void;
    isSelected: boolean;
    isAudio?: boolean;
};

function SelectionOption({
    item,
    SvgRightImage,
    onPress,
    isSelected,
    isAudio = false,
}: Props) {
    const { optionName, onPress: handlePress } = useAudioAndSubtitleOption({
        item,
        onPress,
        isAudio,
    });

    const testID = isAudio
        ? `${AUDIO_LANGUAGE_OPTION}_${item.language}`
        : `${SUBTITLE_OPTION}_${item.language}`;

    return (
        <TouchableOpacity
            style={styles.container}
            activeOpacity={0.5}
            onPress={handlePress}
            accessibilityRole="menuitem"
            accessibilityLabel={optionName}
            aria-selected={isSelected}
            testID={testID}
        >
            <View style={styles.wrapperContent}>
                <Text
                    category={ETextCategory.body1}
                    color={
                        isSelected ? ETextColor.neutral : ETextColor.light_grey
                    }
                >
                    {optionName}
                </Text>
            </View>
            <View style={styles.rightContainer}>
                {SvgRightImage && (
                    <SvgRightImage
                        style={styles.rightImage}
                        fill={COLOR.NEUTRAL}
                    />
                )}
            </View>
        </TouchableOpacity>
    );
}

export default SelectionOption;
